export default __webpack_public_path__ + "static/media/wantedFish.35970817.png";